// src/components/layout/Header.tsx
// CHANGES:
// 1. max-w-7xl changed to max-w-5xl
// 2. Added responsive classes for mobile/tablet

import React from 'react';
import { Shield, Database } from 'lucide-react';

interface HeaderProps {
  systemStatus?: any;
}

export const Header: React.FC<HeaderProps> = ({ systemStatus }) => {
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200/50 shadow-sm">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-4">
        <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-0"> {/* CHANGED: max-w-7xl to max-w-5xl, added responsive flex */}
          <div className="flex items-center gap-4">
            <div className="p-3 rounded-2xl bg-gradient-to-br from-cyan-500 via-blue-500 to-purple-600 shadow-lg">
              <Shield className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-xl sm:text-2xl font-bold"> {/* CHANGED: Added responsive text size */}
                <span className="bg-gradient-to-r from-cyan-600 via-blue-600 to-purple-600 bg-clip-text text-transparent">
                  AI-Powered
                </span>{' '}
                <span className="text-slate-900">KYB Verification</span>
              </h1>
              <p className="text-sm text-slate-600">Enterprise Business Intelligence & Risk Assessment</p>
            </div>
          </div>

          {systemStatus && (
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-green-100 border border-green-300">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                <span className="text-sm font-semibold text-green-700">AI Enhanced</span>
              </div>
              <div className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 border border-blue-300">
                <Database className="w-4 h-4 text-blue-600" />
                <span className="text-sm font-semibold text-blue-700">Live Data</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};